<template>
    <!-- APP ACTIVO -->
    <!-- ES LA VERSION DESDE APP LOS COMPONENTES Y CAMBIOS DE RUTAS -->
    <v-app color="primary">
        <!-- HEADER -->
        <navbar v-if="oidcUser">
            <template v-slot:left>
                <v-btn
                    :ripple="false"
                    color="primary"
                    depressed=""
                    @click="closeSidebar"
                >
                    <v-icon>mdi-apps</v-icon>
                </v-btn>

                <v-container
                    class="pl-1 hidden-sm-and-down"
                    style="width:295px"
                >
                    <a href="https://intraug.ugto.mx/Usuario/ListadoServicios">
                        <v-img
                            :src="require('@/assets/intraug.png')"
                            width="295"
                            alt="logo"
                        />
                    </a>
                </v-container>

                <!-- TITULO CABECERA -->
                <v-toolbar-title
                    class="headline text-uppercase hidden-sm-and-down text-center mr-12 pr-12"
                    style="width: 100%;"
                >
                    <!-- <span class="grey--text">Secretaría Academica/</span> -->
                    <!-- <span class="font-weight-light white--text">Trayectoria Estudiantil UG</span> -->
                </v-toolbar-title>
            </template>

            <template v-slot:right>
                <UserItem
                    v-if="oidcUser && empleadoDatos.Id_Empleado != undefined"
                    :email="oidcUser.email"
                    :nue="empleadoDatos.Id_Empleado"
                />
            </template>

            <template
                v-slot:menu-items
                class="hidden-sm-and-down"
            >
                <Notificacion
                    v-if="oidcAccessToken"
                    :token="oidcAccessToken"
                />
            </template>
        </navbar>
        <!-- HEADER -->

        <!-- MENU INTRAUG -->
        <left-sidebar
            v-if="oidcUser && empleadoDatos.Id_Empleado != undefined"
            :nue="empleadoDatos.Id_Empleado"
            :left="left"
            :close-sidebar="closeSidebar"
            :nombre="empleadoDatos.email"
            :email="empleadoDatos.email"
        />
        <!-- MENU INTRAUG -->

        <v-main>
            <v-sheet
                align="right"
                height="100%"
                style="position: relative; background-color: transparent!important"
                class="overflow-hidden"
            >
                <!--<v-card
                    elevation="0"
                    style="background-color: transparent!important; border-color: transparent!important;"
                    :width="msize"
                >
                     MENU DESPEGABLE - SE USA DEPENDIENDO DEL PROYECTO  
                    <MenuBarra />
                </v-card>-->

                <!-- CONTENIDO -->
                <v-main
                    class="pl-14 pt-0 mx-5 mt-4 mb-8"
                >
<!--                     <errores v-if="administrador"/>
 -->                    <router-view
v-if="$route.meta.isPublic === true || (empleadoDatos && empleadoDatos.Id_Empleado)"
align="left"
/>
                </v-main>
                <!-- CONTENIDO -->

                <!-- MENU IZQUIERDO -->
                <MenuIzquierdo />
            </v-sheet>
        </v-main>

        <Footer class="hidden-sm-and-down" />
        <snackbar />
        <snackbar-pool />
    </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

import {
  UserItem,
  Notificacion,
  Navbar,
  Footer,
  LeftSidebar,
  Comentarios
} from "@/components/layout";

import MenuBarra from "./components/MenuBarra";
import MenuIzquierdo from "./components/MenuIzquierdo";

export default {
  components: {
    UserItem,
    LeftSidebar,
    Notificacion,
    Navbar,
    Footer,
    MenuBarra,
    MenuIzquierdo,
    Snackbar: () => import('@/components/shared/Snackbar'),
    SnackbarPool: () => import('@/components/shared/SnackbarPool'),
    Errores: () => import('@/components/shared/Errores')
  },
  data () {
    return {
      left: false
    };
  },
  computed: {
    ...mapGetters("permiso", ["administrador"]),
    ...mapGetters("oidc", ["oidcUser", "oidcAccessToken"]),
    ...mapState({
      access_token: state => state.oidc.access_token
    }),
    ...mapState(['empleadoDatos']),
    ...mapState(["msize"]),
    estilos () {
      if (this.$vuetify.breakpoint.mdAndDown) return "padding-bottom:10%; ";
      else return "padding-bottom:10%; margin-left: 120px; margin-right:38px;";
    }
  },

  watch: {
    access_token: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.obtenerEmpleado()

          // console.log(newValue);
          // this.consultaAdministrador({ mostrarAlerta: this.mostrarAlerta });
        }
      },
      immediate: true
    }
  },
  async mounted () {
    //console.log("vm", this.$vuetify.breakpoint);
/*     await window.addEventListener('vuexoidc:userLoaded', async (e) => {
      await this.obtenerEmpleado(e)
    }) */
  },
  methods: {
    ...mapActions({
      signOutOidc: "oidc/signOutOidc",
      obtenerEmpleado: "obtenerEmpleado"

    }),

    ...mapActions("permiso", ["consultaAdministrador"]),
    ...mapActions("snackbar", ["mostrarMensaje", "mostrarAlerta"]),

    closeSidebar () {
      this.left = !this.left;
    }
  }
};
</script>

<style>
#app {
  /* FONDOS COLORES
    /* background: #d5d0ba; */
  /* background: #ffffff; */
  /* background: #f9f9f9; */
  background: #f0efed;
}

.v-toolbar__content {
  padding-left: 9px !important;
  padding-right: 9px !important;
}

.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating)
  .v-navigation-drawer__border {
  background-color: transparent !important;
}
</style>
